export class User {

  constructor(public id: number,
              public username: string,
              public firstName: string,
              public lastName: string,
              public email: string,
              public accountNotLocked: boolean,
              public credentialNotExpired: boolean,
              public accountNotExpired: boolean,
              public enabled: boolean) {}

  public get login() {
    return this.username;
  }            
}
